// Route constants
export const ROUTE_PATHS = {
  HOME: "/",
} as const;

// KBO Team data
export interface KBOTeam {
  id: string;
  name: string;
  shortName: string;
  emoji: string;
  primaryColor: string;
  secondaryColor: string;
  glowColor: string;
  /** 다크 배경에서 텍스트/숫자에 사용할 밝은 색상 */
  displayColor: string;
  logoUrl: string;
  city: string;
  founded: number;
}

export const KBO_TEAMS: KBOTeam[] = [
  {
    id: "kia",
    name: "KIA 타이거즈",
    shortName: "KIA",
    emoji: "🐯",
    primaryColor: "#C8201E",
    secondaryColor: "#000000",
    glowColor: "rgba(200, 32, 30, 0.6)",
    displayColor: "#FF5C5A",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/kia_tigers.png",
    city: "광주",
    founded: 1982,
  },
  {
    id: "samsung",
    name: "삼성 라이온즈",
    shortName: "삼성",
    emoji: "🦁",
    primaryColor: "#074CA1",
    secondaryColor: "#C0C0C0",
    glowColor: "rgba(7, 76, 161, 0.6)",
    displayColor: "#5BA3FF",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/samsung_lions.png",
    city: "대구",
    founded: 1982,
  },
  {
    id: "lg",
    name: "LG 트윈스",
    shortName: "LG",
    emoji: "⚡",
    primaryColor: "#C8201E",
    secondaryColor: "#1A1A2E",
    glowColor: "rgba(200, 32, 30, 0.6)",
    displayColor: "#FF5C5A",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/lg_twins.png",
    city: "서울",
    founded: 1990,
  },
  {
    id: "doosan",
    name: "두산 베어스",
    shortName: "두산",
    emoji: "🐻",
    primaryColor: "#131230",
    secondaryColor: "#C8201E",
    glowColor: "rgba(19, 18, 48, 0.8)",
    displayColor: "#FF5C5A",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/doosan_bears.png",
    city: "서울",
    founded: 1982,
  },
  {
    id: "kt",
    name: "KT 위즈",
    shortName: "KT",
    emoji: "🧙",
    primaryColor: "#000000",
    secondaryColor: "#C8201E",
    glowColor: "rgba(200, 32, 30, 0.5)",
    displayColor: "#FF5C5A",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/kt_wiz.png",
    city: "수원",
    founded: 2013,
  },
  {
    id: "ssg",
    name: "SSG 랜더스",
    shortName: "SSG",
    emoji: "🚀",
    primaryColor: "#CE0E2D",
    secondaryColor: "#FDB827",
    glowColor: "rgba(206, 14, 45, 0.6)",
    displayColor: "#FF4D6A",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/ssg_landers.png",
    city: "인천",
    founded: 2000,
  },
  {
    id: "lotte",
    name: "롯데 자이언츠",
    shortName: "롯데",
    emoji: "💪",
    primaryColor: "#002B5C",
    secondaryColor: "#C8201E",
    glowColor: "rgba(0, 43, 92, 0.7)",
    displayColor: "#5BA3FF",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/lotte_giants.png",
    city: "부산",
    founded: 1975,
  },
  {
    id: "hanwha",
    name: "한화 이글스",
    shortName: "한화",
    emoji: "🦅",
    primaryColor: "#F05A28",
    secondaryColor: "#1A1A1A",
    glowColor: "rgba(240, 90, 40, 0.6)",
    displayColor: "#FF8A60",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/hanwha_eagles.png",
    city: "대전",
    founded: 1986,
  },
  {
    id: "nc",
    name: "NC 다이노스",
    shortName: "NC",
    emoji: "🦕",
    primaryColor: "#315288",
    secondaryColor: "#B8B8B8",
    glowColor: "rgba(49, 82, 136, 0.6)",
    displayColor: "#6AADFF",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/nc_dinos.png",
    city: "창원",
    founded: 2011,
  },
  {
    id: "kiwoom",
    name: "키움 히어로즈",
    shortName: "키움",
    emoji: "🦸",
    primaryColor: "#820024",
    secondaryColor: "#FDB827",
    glowColor: "rgba(130, 0, 36, 0.6)",
    displayColor: "#FFD700",
    logoUrl: "https://ssl.gstatic.com/onebox/sports/emblems/kiwoom_heroes.png",
    city: "서울",
    founded: 2008,
  },
];

// Utility — 항상 콤마 구분 전체 숫자 표시 (1,001 / 10,234 등)
export function formatNumber(n: number): string {
  return n.toLocaleString("ko-KR");
}

// Storage helpers
const STORAGE_KEY = "kbo_click_votes";

export function loadVotes(): Record<string, number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // ignore
  }
  return Object.fromEntries(KBO_TEAMS.map((t) => [t.id, 0]));
}

export function saveVotes(votes: Record<string, number>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(votes));
  } catch {
    // ignore
  }
}
